import { getRudderstack } from '@ecomm/shared-window'
import { useEffect, useState } from 'react'

export function useRudderstackAnonymousId(): string {
  const [id, setId] = useState<string>('')

  useEffect(() => {
    getRudderstack(sdk => {
      setId(sdk.getAnonymousId())
    })
  }, [])

  return id
}
